import type { FC } from 'react'
import { withErrorBoundary } from 'react-error-boundary'
import type { ZodError } from 'zod'
import { ViewportRenderer } from './renderers/viewport'
import type { ViewportSchema } from './schemas/viewport'

interface SchemaRendererProps {
  schema?: ViewportSchema
}

function fallbackRender({ error }: { error: ZodError }) {
  return <pre>{JSON.stringify(error, null, 2)}</pre>
}

const Renderer: FC<SchemaRendererProps> = props => {
  const { schema } = props

  if (!schema) return null

  return (
    <div className="antd-schema">
      <ViewportRenderer data={schema} />
    </div>
  )
}

export const SchemaRenderer = withErrorBoundary(Renderer, {
  fallbackRender,
})

export * from './schemas/base'
export * from './schemas/button'
export * from './schemas/card'
export * from './schemas/form'
export * from './schemas/input-number'
export * from './schemas/input-text'
export * from './schemas/service'
export * from './schemas/table'
export * from './schemas/viewport'
